import { Container, Row, Col } from "react-bootstrap";
import "../Footer/footer.css";
import FB from "../../../images/FB.png";
import IG from "../../../images/IG.png";
import TW from "../../../images/TW.png";
import TT from "../../../images/TT.png";
import logo from "/Users/seansaliva/Desktop/web-apps/tcrracing/client/src/images/tcr-racing-logo.png";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <div>
      <Container className="bg-footer mt-2" fluid>
        <Row className="p-3">
          <Col xs={12} md={6} className="text-start">
            <img
              src={logo}
              className="mt-4 mb-3 img-fluid"
              alt="TCR Racing Logo"
            />
          </Col>
          <Col xs={12} md={6} className="text-end">
            <h4 className="mt-4">FOLLOW US ON SOCIAL MEDIA</h4>
            <div className="mt-2">
              <img src={FB} className="img-fluid icons" alt="facebook" />
              <img src={IG} className="img-fluid icons" alt="instagram" />
              <img src={TW} className="img-fluid icons" alt="twitter" />
              <img src={TT} className="img-fluid icons" alt="tiktok" />
            </div>
          </Col>
        </Row>
        <Row className="d-flex justify-content-around">
          <Col xs={12} md={6}>
            <p class="text-white text-start ms-4">
              2023 All Rights Reserved - Tamayo Cosentino Racing Team
            </p>
          </Col>
          <Col
            xs={12}
            md={6}
            className="text-end d-flex justify-content-around"
          >
            <Link className="linkF p-2" exact to="/">
              Home
            </Link>
            <Link className="linkF p-2" to="/Bio">
              Bio
            </Link>
            <Link className="linkF p-2" to="/News">
              News
            </Link>
            <Link className="linkF p-2" to="/Schedule">
              Schedule
            </Link>
            <Link className="linkF p-2" to="/Partners">
              Partners
            </Link>
            <Link className="linkF p-2" to="/Drivers">
              Drivers
            </Link>
            <Link className="linkF p-2" to="/Sponsorships">
              Sponsors
            </Link>
            <Link className="linkF p-2" to="/Contact">
              Contact
            </Link>
            <Link className="linkF p-2" to="/Shop">
              Shop
            </Link>
          </Col>
        </Row>
      </Container>
    </div>
  );
};

export default Footer;
